import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {
	constructor(private router: Router) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap(
				(res: any) => {
					if (environment.logHttp && res && res.body && res.body.esito && res.body) {
						if (res.body.esito === 'OK') {
							console.log('URL:  ', request.url, '\nBody: ', request.body, '\nResp: ', res.body.result);
						} else {
							console.log('URL:  ', request.url, ' \nBody: ', request.body, '\nErrore: ', res.body.descrizione);
						}
					}
				},
				(error) => {
					if (error.status === 401) {
						alert('Wrong credentials or session expired.');
						this.router.navigate(['/login']);
					} else {
						alert(error.message);
					}
				},
			),
		);
	}
}
